import { motion } from "framer-motion";

/** Abstract city/territory silhouette for the hero bottom horizon. */
export function CitySilhouette() {
  return (
    <div
      className="pointer-events-none absolute inset-x-0 bottom-0 -z-[1] opacity-[0.12]"
      style={{ willChange: "transform", transform: "translateZ(0)" }}
    >
      <svg
        viewBox="0 0 1440 320"
        preserveAspectRatio="none"
        className="h-[320px] w-full sm:h-[400px]"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="hsl(var(--foreground) / 0.35)"
          d="M0,320 L0,260 L40,260 L40,220 L80,220 L80,250 L120,250 L120,200 L160,200 L160,240 L200,240 L200,180 L240,180 L240,230 L280,230 L280,160 L320,160 L320,210 L360,210 L360,190 L400,190 L400,240 L440,240 L440,150 L480,150 L480,220 L520,220 L520,170 L560,170 L560,230 L600,230 L600,140 L640,140 L640,200 L680,200 L680,180 L720,180 L720,240 L760,240 L760,160 L800,160 L800,210 L840,210 L840,190 L880,190 L880,250 L920,250 L920,170 L960,170 L960,220 L1000,220 L1000,150 L1040,150 L1040,230 L1080,230 L1080,180 L1120,180 L1120,200 L1160,200 L1160,240 L1200,240 L1200,170 L1240,170 L1240,220 L1280,220 L1280,190 L1320,190 L1320,250 L1360,250 L1360,200 L1400,200 L1400,260 L1440,260 L1440,320 Z"
        />
      </svg>
    </div>
  );
}

/** Decorative infrastructure lines — suggests roads, networks, connections. */
export function InfrastructureLines() {
  return (
    <div
      className="pointer-events-none absolute inset-0 -z-[1] opacity-[0.04]"
      style={{ willChange: "opacity", transform: "translateZ(0)" }}
    >
      <svg className="h-full w-full" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <pattern id="infraPattern" x="0" y="0" width="200" height="200" patternUnits="userSpaceOnUse">
            <path
              d="M0,100 Q50,50 100,100 T200,100 M100,0 Q150,50 100,100 T100,200"
              fill="none"
              stroke="hsl(var(--foreground))"
              strokeWidth="1"
            />
            <circle cx="100" cy="100" r="2" fill="hsl(var(--primary))" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#infraPattern)" />
      </svg>
    </div>
  );
}

/** A softly glowing orb used as an editorial accent. */
export function AccentOrb({
  className,
  color = "primary",
}: {
  className?: string;
  color?: "primary" | "secondary" | "tertiary";
}) {
  const colors = {
    primary: "hsl(152 40% 45% / 0.18)",
    secondary: "hsl(210 45% 50% / 0.16)",
    tertiary: "hsl(35 70% 55% / 0.18)",
  };
  return (
    <motion.div
      initial={{ scale: 0.9, opacity: 0.6 }}
      animate={{ scale: [0.9, 1.05, 0.9], opacity: [0.6, 0.85, 0.6] }}
      transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
      className={`pointer-events-none rounded-full blur-[90px] ${className || ""}`}
      style={{ background: colors[color], willChange: "transform, opacity", transform: "translateZ(0)" }}
    />
  );
}

